module.exports = __webpack_public_path__ + "img/cpzz17@2x.9999f7dc.png";